import uuid from 'uuid';

import {
  TYPE_DEFAULT,
  TYPE_SUCCESS,
  TYPE_ERROR,
} from '../lib/notifications/types';

export const addNotification = (message, type, id = uuid.v4()) => dispatch => {
  dispatch({ type: 'NOTIFICATION_ADD', notification: { message, type, id } });
};

export const addDefaultNotification = (message, id) => dispatch => {
  dispatch(addNotification(message, TYPE_DEFAULT, id));
};

export const addSuccessNotification = (message, id) => dispatch => {
  dispatch(addNotification(message, TYPE_SUCCESS, id));
};

export const addErrorNotification = (message, id) => dispatch => {
  dispatch(addNotification(message, TYPE_ERROR, id));
};

export const consumeNotification = id => dispatch => {
  dispatch({ type: 'NOTIFICATION_CONSUME', id });
};
